"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgMessageCircle = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M16.581 31.419l3.803-1.268a1 1 0 01.767.056A7.382 7.382 0 0024.5 31a7.502 7.502 0 006.707-4.15A7.38 7.38 0 0032 23.502l.002-.448C31.792 19.248 28.752 16.21 25 16h-.503a7.385 7.385 0 00-3.35.795A7.5 7.5 0 0017 23.503a7.38 7.38 0 00.793 3.346 1 1 0 01.056.767L16.58 31.42zm16.414-3.672A9.5 9.5 0 0124.503 33a9.38 9.38 0 01-3.87-.824l-5.317 1.773a1 1 0 01-1.265-1.265l1.773-5.318a9.498 9.498 0 014.425-12.359A9.378 9.378 0 0124.5 14l.555.002C29.88 14.268 33.732 18.12 34 23v.499a9.376 9.376 0 01-1.005 4.248z",
    id: "message-circle_svg__a"
  }));
};

var _default = SvgMessageCircle;
exports.default = _default;